var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#fff",
    rx: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0E0F0C",
    d: "m33.343 22.543-8.573-8.571a.83.83 0 0 0-1.2 0L15 22.542l1.2 1.2 7.114-7.113v17.657h1.715V16.63l7.114 7.114z"
  })));
};
export default SvgArrow;